document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll("[data-parallax]");
  let ticking = false;

  function handleScroll() {
    const scrollY = window.scrollY;

    // 小屏幕禁用（宽度 < 1440）
    if (window.innerWidth < 1440) {
      // 清除 transform，保持布局正常
      targets.forEach((el) => (el.style.transform = ""));
      return;
    }

    if (!ticking) {
      window.requestAnimationFrame(() => {
        targets.forEach((el) => {
          const axis = el.dataset.direction || "y";
          const speed = parseFloat(el.dataset.speed) || 0.1;
          const sign = el.dataset.sign === "-" ? -1 : 1;
          const offset = scrollY * speed * sign;

          if (axis === "x") {
            el.style.transform = `translateX(${offset}px)`;
          } else {
            el.style.transform = `translateY(${offset}px)`;
          }
        });
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener("scroll", handleScroll);

  // 监听窗口大小变化，动态启用/禁用
  window.addEventListener("resize", () => {
    if (window.innerWidth < 1440) {
      targets.forEach((el) => (el.style.transform = ""));
    } else {
      handleScroll(); // 重新应用位置
    }
  });
});
